// extracted by mini-css-extract-plugin
export default {"link":"_4e360c1f"};